// blog.ts
// Store for getting blog posts

import { ref } from 'vue'
import { defineStore } from 'pinia'

export interface Post {
  id: number
  title: string
  content: string
}

export const useBlogStore = defineStore('blog', () => {
  const posts = ref([] as Post[])

  const fetchPosts = async () => {
    const response = await fetch('/api/blog/')
    const data = await response.json()
    posts.value = data
  }

  return { posts, fetchPosts }
})
